import * as Oidc from 'oidc-client';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AuthorizedUserService } from '../services/authorizedUserService';
import { Settings } from '../Settings';

export class LoginComponent extends React.Component<any, any> {
  componentWillMount() {
    const manager = new Oidc.UserManager(Settings);

    if (this.props.location.hash) {
      manager.signinRedirectCallback().then((u) => this.props.login(u));
    } else {
      manager.signinRedirect();
    }
  }

  render() {
    return null;
  }
}
export default withRouter(connect(undefined, mapDispatchToProps)(LoginComponent) as any);

function mapDispatchToProps(dispatch: any, ownProps: any) {
  return {
    async login(user: any) {
      const userPermissions = await AuthorizedUserService.getUserByEmail(user.profile.email, user);
      dispatch({ type: 'USER_LOGIN', loggedInUser: user, userPermissions });
      ownProps.history.push('/');
    }
  };
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/authentication/components/Login.tsx